<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_display_ceu_title' | translate: { name: data.formula.displayName } }}</h4>

  <table mat-table [dataSource]="ceuValues" class="mat-elevation-z8">
    <!-- Colonne : Code -->
    <ng-container matColumnDef="ceu_column_code">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_code' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['Code'] }}</td>
    </ng-container>

    <!-- Colonne : Nom -->
    <ng-container matColumnDef="ceu_column_name">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_name' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['DisplayName'] }}</td>
    </ng-container>

    <!-- Colonne : Unité d'oeuvre -->
    <ng-container matColumnDef="ceu_column_work_unit">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_work_unit' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['WorkUnity'] }}</td>
    </ng-container>

    <!-- Colonne : Materiaux -->
    <ng-container matColumnDef="ceu_column_materials">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_materials' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['MaterialCost'] }}</td>
    </ng-container>

    <!-- Colonne : Transport en amont -->
    <ng-container matColumnDef="ceu_column_upstream_transport">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_upstream_transport' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['InitialTransportCost'] }}</td>
    </ng-container>

    <!-- Colonne : Fabrication mélangée -->
    <ng-container matColumnDef="ceu_column_mixed_manufacturing">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_mixed_manufacturing' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['MaterialMakingCost'] }}</td>
    </ng-container>

    <!-- Colonne : Fret entrant sur le chantier -->
    <ng-container matColumnDef="ceu_column_incoming_freight">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_incoming_freight' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['BuildTransportCostIn'] }}</td>
    </ng-container>

    <!-- Colonne : Materiaux -->
    <ng-container matColumnDef="ceu_column_implementation">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_implementation' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['WorkingCost'] }}</td>
    </ng-container>

    <!-- Colonne : Fret sortant du chantier -->
    <ng-container matColumnDef="ceu_column_outgoing_freight">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_outgoing_freight' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['BuildTransportCostOut'] }}</td>
    </ng-container>

    <!-- Colonne : Autres -->
    <ng-container matColumnDef="ceu_column_others">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_other' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['OtherCost'] }}</td>
    </ng-container>

    <!-- Colonne : Total -->
    <ng-container matColumnDef="ceu_column_total">
      <th mat-header-cell *matHeaderCellDef>{{ 'dialog_display_ceu_col_total' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.values['TotalCost'] }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>

  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_back' | translate }}</button>
  </div>
</div>
